import { ITariffAdditionalEntry } from './product-group.interfaces';

export function isDateAdditionalEntry(entry: ITariffAdditionalEntry): boolean {
  const dataType: string = entry.additionalEntryDataType || entry.dataType;

  return ['Datum', 'DatumUhrzeit', 'DatumZeit', 'Date', 'DateTime'].includes(
    dataType
  );
}
